export interface OAuthRuntimeConfig {
  OAUTH_PUBLIC_BASE_URL?: string;
  OAUTH_BASE_URL?: string;
  OAUTH_LOGIN_PATH?: string;
  OAUTH_REDIRECT_URI?: string;
  FAKE_GOV_SSO_USER?: string;
}

declare global {
  interface Window {
    __ECR_OAUTH_CONFIG__?: OAuthRuntimeConfig;
  }
}

export interface OAuthClientConfig {
  baseUrl: string;
  loginPath: string;
  redirectUri: string;
}

function getRuntimeConfig(): OAuthRuntimeConfig {
  if (typeof window === 'undefined') {
    return {};
  }

  return window.__ECR_OAUTH_CONFIG__ || {};
}

function getEnvValue(key: keyof OAuthRuntimeConfig): string | undefined {
  switch (key) {
    case 'OAUTH_BASE_URL':
      return process.env.OAUTH_BASE_URL;
    case 'OAUTH_PUBLIC_BASE_URL':
      return process.env.OAUTH_PUBLIC_BASE_URL;
    case 'OAUTH_LOGIN_PATH':
      return process.env.OAUTH_LOGIN_PATH;
    case 'OAUTH_REDIRECT_URI':
      return process.env.OAUTH_REDIRECT_URI;
    case 'FAKE_GOV_SSO_USER':
      return process.env.FAKE_GOV_SSO_USER;
    default:
      return undefined;
  }
}

export function getOAuthClientConfig(): OAuthClientConfig {
  const runtimeConfig = getRuntimeConfig();
  const baseUrl =
    runtimeConfig.OAUTH_PUBLIC_BASE_URL ||
    runtimeConfig.OAUTH_BASE_URL ||
    getEnvValue('OAUTH_PUBLIC_BASE_URL') ||
    getEnvValue('OAUTH_BASE_URL') ||
    '';
  const loginPath = runtimeConfig.OAUTH_LOGIN_PATH || getEnvValue('OAUTH_LOGIN_PATH') || '/ns-jckj/login/redirectlogin';
  const redirectUri = runtimeConfig.OAUTH_REDIRECT_URI || getEnvValue('OAUTH_REDIRECT_URI') || '/sso/callback';

  return {
    baseUrl,
    loginPath,
    redirectUri,
  };
}

function resolveUrl(baseUrl: string, value: string): string {
  const origin = typeof window !== 'undefined' && window.location?.origin ? window.location.origin : 'http://localhost';
  const base = baseUrl ? new URL(baseUrl, origin).toString() : origin;
  return new URL(value, base).toString();
}

export function buildOAuthCallbackUri(redirectParam?: string): string {
  const config = getOAuthClientConfig();
  const callbackUri = config.redirectUri || '/sso/callback';
  const origin = typeof window !== 'undefined' && window.location?.origin ? window.location.origin : 'http://localhost';
  const callbackUrl = new URL(callbackUri, origin);

  if (redirectParam) {
    callbackUrl.searchParams.set('redirect', redirectParam);
  }

  return callbackUrl.toString();
}

export function buildOAuthLoginUrl(redirectParam?: string): string {
  const config = getOAuthClientConfig();
  const loginUrl = new URL(resolveUrl(config.baseUrl, config.loginPath));
  loginUrl.searchParams.set('redirectUri', buildOAuthCallbackUri(redirectParam));
  return loginUrl.toString();
}

export function getPortalSsoUserHint(): string | undefined {
  const runtimeConfig = getRuntimeConfig();
  return runtimeConfig.FAKE_GOV_SSO_USER || getEnvValue('FAKE_GOV_SSO_USER');
}
